module.exports = __webpack_public_path__ + "img/icon05.5e300df8.png";